/**
 * Deprecated blog slugs → logical SEO paths (301-style client redirect + firebase.json).
 * Content merged into hub pages to reduce cannibalization.
 */
export const BLOG_SLUG_REDIRECTS = {
  'prime-document-sign-encryption-firebase-google-cloud-security': '/trust',
  'how-audit-trails-work-esignature-software': '/trust',
  'is-it-safe-to-sign-documents-online': '/trust',
  'are-electronic-signatures-legally-binding': '/what-is-esignature',
  'how-to-create-legally-binding-agreement-electronic-signature': '/what-is-esignature',
  'prime-document-sign-youtube-social-media-official': '/reviews',
  'why-prime-document-sign-is-trusted-software': '/trust',
  'prime-document-sign-legal-esign-us-eu-au': '/trust',
  'prime-document-sign-audit-trails-explained': '/trust',
  'verify-prime-document-sign-australian-company-google': '/trust',
  'what-is-prime-document-sign-who-built-it': '/product',
  'prime-document-sign-client-data-trust': '/trust',
  'prime-document-sign-is-it-secure-and-trusted': '/trust',
  'prime-document-sign-google-business-trust-reviews': '/reviews',
  'electronic-signature-audit-trail-what-is-included': '/trust',
  'fair pricing you can understand': '/blog/fair-pricing-you-can-understand',
  'contract signing for agencies': '/blog/contract-signing-for-agencies',
  'best esignature software real estate': '/blog/best-esignature-software-real-estate',
  'how to send contracts for signature': '/blog/how-to-send-contracts-for-signature',
  'how to sign a pdf online': '/blog/how-to-sign-a-pdf-online',
  'prime document sign browsers chrome safari edge': '/blog/prime-document-sign-browsers-chrome-safari-edge',
  'prime document sign nda hr real estate use cases': '/blog/prime-document-sign-nda-hr-real-estate-use-cases',
  'prime document sign support speed priority all plans': '/blog/prime-document-sign-support-speed-priority-all-plans',
  'prime document sign compared pandadoc docusign reddit': '/blog/prime-document-sign-compared-pandadoc-docusign-reddit',
  'prime document sign free trial first send': '/blog/prime-document-sign-free-trial-first-send',
  'sign on phone without app prime document sign': '/blog/sign-on-phone-without-app-prime-document-sign',
  'prime document sign freelancers reddit worth it': '/blog/prime-document-sign-freelancers-reddit-worth-it',
  'prime document sign pricing worth it': '/blog/prime-document-sign-pricing-worth-it',
  'prime document sign international outside australia': '/blog/prime-document-sign-international-outside-australia',
  'prime document sign vs docusign small business reddit': '/blog/prime-document-sign-vs-docusign-small-business-reddit',
  'prime document sign where use devices worldwide': '/blog/prime-document-sign-where-use-devices-worldwide',
  'prime document sign customer support how to contact': '/blog/prime-document-sign-customer-support-how-to-contact',
  'docusign vs prime document sign': '/blog/docusign-vs-prime-document-sign',
  'docusign too expensive cheaper alternatives': '/blog/docusign-too-expensive-cheaper-alternatives',
  'is electronic signature legal in australia': '/blog/is-electronic-signature-legal-in-australia',
  'how to sign documents online': '/blog/how-to-sign-documents-online',
  'cheap esignature tools for small business': '/blog/cheap-esignature-tools-for-small-business',
  'best esignature for freelancers and contracts': '/blog/best-esignature-for-freelancers-and-contracts',
  'e signature document signing guide': '/blog/e-signature-document-signing-guide',
  'easiest fillable fields esignature': '/blog/easiest-fillable-fields-esignature',
  'cheap esignature software-2026': '/blog/cheap-esignature-software-2026',
  'best docusign alternatives under-5-dollars': '/blog/best-docusign-alternatives-under-5-dollars',
}
